const PAGES_LINKS = {
  home: {
    root: '/home',
    rechargeSuccess: '/hesabi-checkout-topup',
    invoicedSuccess: '/hesabi-checkout-invoice',
    plansDetails: '/plans-details',
    payBills: '/pay-bills',
    installmentDetails: 'installment-details',
    RechargeBalance: '/recharge-balance',
    bundlePage: '/bundle-details',
    offerDetailsPage: '/offer-details',
    allOffers: '/all-offers',
    campaignOfferNoGifts: '/campaign-offer-no-gifts',
    campaignOfferGifts: '/campaign-offer-gifts',
    billsDetailsPage: '/bills-details',
    devices: '/devices',
    usage: '/usage-details',
  },
  more: {
    root: '/more',
    transactionHistory: '/transaction-history',
    numberManagement: '/number-management',
    jawwalApp: '/jawwal-app',
    aboutApp: '/about-app',
    settings: '/settings',
    share: '/share',
    supportAndHelp: {
      root: '/support-and-help',
      rating: '/rating',
      showrooms: '/show-rooms',
      callUs: '/callUs',
      followUp: '/followUp',
      iframePage: '/iframe',
      troubleTicket: '/trouble-ticket',
      trackYourOrder: '/track-your-order',
      fixedFollowUp: '/fixed-follow-up',
    },
    termsAndCondition: '/terms-and-condition',
    corporate: {
      root: '/corporate-main',
      mainPage: '/corporate-main-page',
      subRoot: '/sub-roots-account',
      subscriber: '/subscribers',
      numberDetails: '/number-details',
      orderNumbers: '/orders',
      corpCheckoutInvoice: '/corp-checkout-invoice',
      addFollowUp: '/add-follow-up',
      service: {
        root: '/corporate-service',
        lineService: '/lines',
        swipeSim: '/swipe-sim',
        connectYourLine: '/connect-your-line',
        tempDeactivateAndReconnect: '/temp-deactivate-and-reconnect',
        individualUser: '/individual-user',
        lineInstallment:'/line-installments',
        directDebt:'/direct-debit',
        installations: '/installations'
      },
    },
    deviceManagement: '/device-management',
    cardsManagement: '/cards-management',
    paltelCorporate: {
      root: '/paltel-corporate-main',
      accountInfo: '/account-information',
      paltelSubscribersPage: '/paltel-subscribers',
      troubleTicket: '/trouble-ticket',
      addTroubleTicketFixedLine: '/add-trouble-ticket-fixedline',
      addTroubleTicketDataIP: '/add-trouble-ticket-dataIP',
      invoiceDetails: '/invoice-details',
      orders: '/orders',
    },
  },
  service: {
    root: '/service',
    bundlePage: '/bundle-categories-page',
    selectedNumberCampaign: '/selected-number-campaign',
    roaming: {
      root: '/roaming',
      local: '/local-roaming',
      international: '/international-roaming',
      countryInfo: '/country-info',
      tipsPage: '/roaming-tips',
      family: '/family-roaming',
      countrySelection: '/family-roaming/country-selection',
      familySummary: '/family-roaming/summary',
    },
    MCN: '/MCN',
    vas: '/vas',
    transferBalance: '/transfer-balance',
    selectedNumber: '/selected-number',
    microLoans: '/micro-loans',
    safeInternet: '/safe-internet',
    connectYourLine: '/connect-your-line',
    temporaryDeactivation: '/temporary-deactivation',
    selectYourNumber: '/select-your-number',
    callMeBack: '/call-me-back',
    simSwap: '/sim-swap',
    balanceHistory: '/balance-history',
    giftSharing: '/send-gift',
    selectGift: '/select-gift',
    gifts: '/gifts',
    termsAndConditions: '/terms-Conditions',
    recurringPayment: '/recurring-payment',
    recurringPaymentTerms: '/recurring-payment-terms',
    zeroService: {
      root: '/zeros',
      mobile: '/mobile-zeros',
      international: '/international-zeros',
    },
    fixedLineServices: {
      root: '/fixedLineServices',
      changeNumber: '/change-number',
      changeLocation: '/change-location',
      changeLocationTc: '/terms-conditions',
    },
    billServices: {
      root: '/billServices',
      eBill: '/e-bill',
      billviaSMS: '/bill-via-sms',
    },
    serviceDetails: {
      root: '/serviceDetails',
    },
    paltelBook: {
      root: '/paltelBook',
    },
    uber: '/uber',
    orderTracking: {
      root: '/orderTracking',
      details: '/details',
      detailsWithId: '/details/:orderNo',
    },
    newSubscriptionRequest: {
      root: '/new-subscption-request',
      otpVerification: '/otp-verification',
      map: '/map',
    },
    points: {
      root: '/points',
    },
    maddedha: '/maddedha',
    simPukCode: '/sim-puk-code',
    ramadan: {
      ramadanOffers: '/offers',
      ramadanBundlesBalances: '/bundles',
      campaignDetails: '/campaign-details',
    },
    baringCalls: '/baring-calls',
    warranty: '/warranty',
    directDebt: '/direct-debit',
    routerSettings: '/router_settings',
    networkDevices: 'network-devices',
    fiber: {
      root: '/fiber',
      bookAVisit: '/book-visit',
    },
    fiberTool: '/fiber-tool',
    speedUpgradeADSL: {
      root: '/speed-upgrade-adsl',
      speedUpgradeSummary: '/speed-upgrade-summary',
      termsAndConditions: '/terms-and-conditions',
    },
    superfastInternet: {
      root: '/superfast-internet',
      superfastInternetAddOns: '/superfast-internet-addOns',
      superfastInternetSummary: 'superfast-internet-summary',
    },
    buyForAnotherNumber:'/buy-for-another-number',
    payBillsForOthers:'/pay-bills-for-others'
  },
  store: '/store',
  landingPage: '/landing-page',
  JPCallBack: '/jawwal-call-back',
  main: '/',
  profile: '/profile',
  addReflectInfo: '/add-reflect-info',
  updateReflectInfo: '/update-reflect-info',
  quickAccess: {
    usage: '/usage',
    freeSMS: '/free-messages',
    quickAccess: '/quick-access',
  },
}

export default PAGES_LINKS
